module.exports = __webpack_public_path__ + "img/money.9034dc98.jpg";